import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import closeIcon from '../../assets/close.svg';
import plusIcon from '../../assets/plus-icon-large.svg';
import flowChartIcon from '../../assets/flow-chart-icon.svg';
import contentIcon from '../../assets/content-icon.svg';
import cssClass from './CustomizationModal.module.css';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';


// Animation variants
const animationVariants = {
  backdrop: {
    hidden: {
      opacity: 0,
      transition: { duration: 0.3 },
    },
    visible: {
      opacity: 1,
      transition: { duration: 0.2 },
    },
  },
  modal: {
    hidden: {
      y: 20,
      // scale: 0.8,
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: 'easeInOut',
      },
    },
    visible: {
      y: 0,
      // scale: 1,
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      },
    },
    exit: {
      y: 40,
      transition: {
        duration: 0.3,
        ease: 'easeInOut',
      },
    },
  },
};

const CustomizationModal = ({ roadmap, setSelectedRoadmap }) => {
  const { userDetails } = useContext(UserContext);
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  const handleCustomizeRoadmap = async (roadmap, cloneType) => {
    try {
      const data = {
        e: userDetails?.email,
        r_title: roadmap?.title,
        r_desc: roadmap?.description,
        ref_rid: roadmap?.id,
        cln_t: cloneType,
      };
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/r/create-roadmap`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          // credentials: 'include',
          body: JSON.stringify(data),
        },
      );
      const responseData = await response.json();
      if (response.status === 201) {
        const roadmapId = responseData?.id;
        navigate(`/draw-roadmap/${roadmapId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeCustomizationModal = (event) => {
    event.stopPropagation();
    setSelectedRoadmap(null);
  };

  return (
    <motion.div
      className={cssClass['backdrop']}
      onClick={closeCustomizationModal}
      variants={animationVariants.backdrop} initial='hidden' animate='visible' exit='hidden' key='backdrop'
      >
      <motion.div
        className={cssClass['modal']}
        onClick={(e) => e.stopPropagation()}
        variants={animationVariants.modal} initial='hidden' animate='visible' exit='exit' key='modal'
        >
        <button
          className={cssClass['action-btn']}
          onClick={() => handleCustomizeRoadmap(roadmap, 'partial')}
        >
          <div className={cssClass['icon-ct']}>
            <img src={flowChartIcon} className={cssClass['flowchart-icon']} alt="" />
          </div>
          <p>Clone Roadmap Diagram Only</p>
          
        </button>
        <button
          className={cssClass['action-btn']}
          onClick={() => handleCustomizeRoadmap(roadmap, 'all')}
        >
          <div className={cssClass['icon-ct']}>
            <img src={flowChartIcon} className={cssClass['flowchart-icon']} alt="" />
            <img src={plusIcon} className={cssClass['plus-icon']} alt="" />
            <img src={contentIcon} className={cssClass['content-icon']} alt="" />
          </div>
          <p>Clone Roadmap with Content</p>
          
        </button>
        <button
          className={cssClass['close-btn']}
          onClick={closeCustomizationModal}
        >
          <img src={closeIcon} alt="close" />
        </button>
      </motion.div>
    </motion.div>
  );
};

CustomizationModal.propTypes = {
  roadmap: PropTypes.object.isRequired,
  setSelectedRoadmap: PropTypes.func.isRequired,
};

export default CustomizationModal;
